<template>
  <div class="h-screen w-screen fixed top-0 left-0 z-20">
    <div class="h-full w-full absolute top-0 left-0 bg-blue-500 opacity-50"></div>
    <div class="h-full w-full absolute top-0 left-0 flex">
      <div class="max-h-full max-w-full m-auto">
        <slot></slot>
      </div>
    </div>
    <div class="absolute top-5 right-5 text-white">
      <svg xmlns="http://www.w3.org/2000/svg" @click="$emit('modal-close')" class="h-6 w-6 cursor-pointer" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: "Modal",
}
</script>